<p-confirmDialog key="history" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div *ngIf="LockerExists() == false" class="HistoryHeading">
	<h4>Select a locker to view its history</h4>
</div>

<div *ngIf="LockerExists() == true" class="HistoryHeading">
	<h4>Locker History for: {{ LockerNum }}</h4>
</div>

<!--Table-->
<div *ngIf="LockerExists() == true" class="table-main-body">
	<p-table
		#mydt
		[value]="lstLockerPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedLockerPerson"
		dataKey="LockerPersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StudentID-->
				<th>
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--MoveInDate-->
				<th>
					<!-- <p-columnFilter type="text" field="MoveInDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--MoveOutDate-->
				<th>
					<!-- <p-columnFilter type="text" field="MoveOutDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Comments-->
				<th class="CommentWidth">
					<p-columnFilter type="text" field="Comments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="ButtonWidth"></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="MoveInDate">Date In<p-sortIcon field="MoveInDate"></p-sortIcon></th>
				<th pSortableColumn="MoveOutDate">Date Out<p-sortIcon field="MoveOutDate"></p-sortIcon></th>
				<th class="CommentWidth" pSortableColumn="Comments">Comments<p-sortIcon field="Comments"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>

				<th class="ButtonWidth"></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-LockerPerson>
			<tr [pSelectableRow]="LockerPerson" (dblclick)="onRowDblClick(LockerPerson)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ LockerPerson[col.field] }}
				</td>

				<td class="CommentWidth">
					<textarea style="width: 100%; height: 100%" [(ngModel)]="LockerPerson.Comments"></textarea>
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="LockerPerson.Active == true ? 'Black' : 'Red'">
					{{ LockerPerson["ActiveDesc"] }}
				</td>

				<td class="ButtonWidth">
					<button [disabled]="IsLoading() == true" class="btn btn-primary" style="padding: 5px" (click)="onSave(LockerPerson)">Save</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
